export const DraftInventoryItemId = -1;

export const GetAllInventoryItemsRequestKey = "getAllInventoryItems";
export const SubmitInventoryItemsRequestKey = "submitInventoryItems";
export const FlushInventoryItemsRequestKey = "flushInventoryItems";
export const CreateInventoryItemRequestKey = "createInventoryItem";
export const CreateInventoryItemsRequestKey = "createInventoryItems";
export const ImportItemsRequestKey = "importItems";
